import React, { useCallback, useState } from 'react';
import { STORAGE_BOX_COLOR_TAGS } from '../constants';
import { useStorageBox } from '../StorageBoxContext';
import { colorTagDisplayName, colorTagHex } from '../utils/itemMetaDisplay';
import StorageBoxSidebarSection, {
  readSidebarSectionExpanded,
  writeSidebarSectionExpanded,
} from './StorageBoxSidebarSection';
import { useStorageBoxSidebarDrawer } from '../StorageBoxSidebarDrawerContext';

const SECTION_KEY = 'sb-sidebar-tags-expanded';
const TAG_OPTIONS = STORAGE_BOX_COLOR_TAGS.filter((t) => t.id);

export default function StorageBoxSidebarColorTags() {
  const {
    readOnly,
    browseMode,
    activeColorTag,
    openColorTagView,
    vaultScope,
    lockVaultAccessActive,
  } = useStorageBox();
  const inLockRealm = vaultScope === 'lock';
  const lockUnlocked = lockVaultAccessActive;
  const [expanded, setExpanded] = useState(() => readSidebarSectionExpanded(SECTION_KEY, false));
  const closeDrawer = useStorageBoxSidebarDrawer();

  const toggleExpanded = useCallback(() => {
    setExpanded((v) => {
      const next = !v;
      writeSidebarSectionExpanded(SECTION_KEY, next);
      return next;
    });
  }, []);

  if (readOnly) return null;
  if (inLockRealm && !lockUnlocked) return null;

  return (
    <StorageBoxSidebarSection
      title={inLockRealm ? 'Lock tags' : 'Tags'}
      expanded={expanded}
      onToggle={toggleExpanded}
      className="sb-drive-tags-nav"
    >
      <p className="sb-drive-sidebar-section__hint">Click a colour to see all matching items.</p>
      <div className="sb-drive-tags-nav__palette" role="list" aria-label="Colour tags">
        {TAG_OPTIONS.map((tag) => {
          const active = browseMode === 'colorTag' && activeColorTag === tag.id;
          const hex = colorTagHex(tag.id);
          return (
            <button
              key={tag.id}
              type="button"
              role="listitem"
              className={`sb-drive-tags-nav__swatch-btn${active ? ' sb-drive-tags-nav__swatch-btn--active' : ''}`}
              onClick={() => {
                openColorTagView(tag.id);
                closeDrawer();
              }}
              title={tag.label}
              aria-label={`${tag.label} tag`}
              aria-current={active ? 'true' : undefined}
            >
              <span
                className="sb-color-swatch sb-color-swatch--sidebar-tag"
                style={hex ? { backgroundColor: hex } : undefined}
                aria-hidden
              />
              <span className="sb-drive-tags-nav__swatch-label">{colorTagDisplayName(tag.id)}</span>
            </button>
          );
        })}
      </div>
    </StorageBoxSidebarSection>
  );
}
